import * as React from 'react';

import { PropertySpecialFeatures } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

interface SpecialFeaturesProps extends SharedUiWrapperProps {
  columns?: number;
}

const SpecialFeaturesWrapper: React.FC<SpecialFeaturesProps> = ({ inputs, columns }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <PropertySpecialFeatures inputs={inputs} columns={columns} />
  </UitkSpacing>
);

export const SharedUiSpecialFeaturesWrapper = withSharedUiPropertyDetails(SpecialFeaturesWrapper);
SharedUiSpecialFeaturesWrapper.displayName = 'SharedUiSpecialFeaturesWrapper';
